import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { requisitionsApi } from '../api';
import PageHeader from '../components/PageHeader';
import StatusBadge from '../components/StatusBadge';
import { ChevronRight, Loader2 } from 'lucide-react';

export default function MyRequisitions() {
  const { user, theme } = useAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    requisitionsApi.list().then(setList).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="My requisitions" subtitle={`${user?.branchCode} · click a requisition number to open it and download as Excel`} />

      <div className="fm-card overflow-hidden">
        <table className="w-full text-[14px]">
          <thead>
            <tr className="text-left text-[12px] text-[#7a6f5c] border-b border-[#E7E2D3]">
              <th className="px-5 py-3 font-medium">Requisition No.</th>
              <th className="px-5 py-3 font-medium">Date</th>
              <th className="px-5 py-3 font-medium text-center">SKUs</th>
              <th className="px-5 py-3 font-medium text-center">Total Qty</th>
              <th className="px-5 py-3 font-medium">Status</th>
              <th className="px-5 py-3 font-medium text-right pr-6"></th>
            </tr>
          </thead>
          <tbody>
            {loading && (<tr><td colSpan={6} className="px-5 py-10 text-center text-[#7a6f5c]"><Loader2 className="animate-spin inline" /></td></tr>)}
            {!loading && list.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-10 text-center text-[#7a6f5c]">You haven't raised any requisitions yet.</td></tr>
            )}
            {!loading && list.map(r => (
              <tr key={r.id} className="fm-row border-t border-[#EFEADC]">
                <td className="px-5 py-4 font-mono text-[13px]">
                  <Link to={`/app/requisitions/${encodeURIComponent(r.id)}`} className="underline" style={{ color: theme.primary }}>{r.id}</Link>
                </td>
                <td className="px-5 py-4 text-[13px]">{r.date}</td>
                <td className="px-5 py-4 text-center">{r.lines.length}</td>
                <td className="px-5 py-4 text-center">{r.lines.reduce((s,l)=>s+l.qty,0)}</td>
                <td className="px-5 py-4">
                  <div className="flex items-center gap-2">
                    <StatusBadge status={r.status} />
                    <span className="text-[11.5px] text-[#7a6f5c]">{r.lines.filter(l=>l.lineStatus==='Delivered').length}/{r.lines.length} delivered</span>
                  </div>
                </td>
                <td className="px-5 py-4 text-right pr-6">
                  <Link to={`/app/requisitions/${encodeURIComponent(r.id)}`} className="inline-flex items-center gap-1 text-[13px] text-[#232323] hover:text-black">
                    <ChevronRight size={14}/> Open
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
